import React from 'react';
import PropTypes from 'prop-types';
import { TextField } from 'next-common-lib';
import i18n from 'i18n';

export const TextFieldFormik = ({
  id,
  formik,
  maxLength,
  componentType,
  className,
  width,
  height,
  disabled,
  autoFocus,
  placeholderLabel,
  label,
  useExpLabel,
  inputBtnOptionsArr,
  readonly,
  timerCount,
  timerCallback,
  restrictCallback,
}) => {
  const fieldHelpers = formik.getFieldHelpers(id);
  const fieldMeta = formik.getFieldMeta(id);

  let validationObject = {
    onChange: e => {
      fieldHelpers.setTouched(true);
      fieldHelpers.setValue(e.target.value);
    },
    onDelete: () => {
      fieldHelpers.setTouched(true);
      fieldHelpers.setValue('');
    },
  };

  if (useExpLabel && fieldMeta.touched) {
    validationObject = {
      ...validationObject,
      validation: fieldMeta.error === undefined,
      error: fieldMeta.error !== undefined,
      failLabel: i18n.t(fieldMeta.error),
    };
  }

  let _inputBtnOptionsArr = {};
  if (componentType === 'inputBtnSeparate') {
    _inputBtnOptionsArr = {
      inputBtnOptionsArr,
    };
  }

  return (
    <div className="input-group-wrap">
      <TextField
        id={id}
        maxLength={maxLength}
        componentType={componentType}
        className={className}
        width={width}
        height={height}
        disabled={disabled}
        readonly={readonly}
        autoFocus={autoFocus}
        placeholderLabel={placeholderLabel}
        label={label}
        useExpLabel={useExpLabel}
        timerCount={timerCount}
        timerCallback={timerCallback}
        onRestrict={restrictCallback}
        {...validationObject}
        {..._inputBtnOptionsArr}
      />
    </div>
  );
};

TextFieldFormik.propTypes = {
  id: PropTypes.string.isRequired,
  formik: PropTypes.object.isRequired,
  maxLength: PropTypes.number.isRequired,
  componentType: PropTypes.string,
  className: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  disabled: PropTypes.bool,
  useExpLabel: PropTypes.bool,
  autoFocus: PropTypes.bool,
  placeholderLabel: PropTypes.string,
  label: PropTypes.string,
  inputBtnOptionsArr: PropTypes.object,
  readonly: PropTypes.bool,
  timerCount: PropTypes.string,
  timerCallback: PropTypes.func,
  restrictCallback: PropTypes.func,
};
TextFieldFormik.defaultProps = {
  componentType: 'input',
  className: '',
  width: null,
  height: null,
  disabled: false,
  useExpLabel: true,
  autoFocus: false,
  placeholderLabel: '',
  label: '',
  inputBtnOptionsArr: {},
  readonly: false,
  timerCount: '',
  timerCallback: () => {},
  restrictCallback: () => {
    return true;
  },
};
export default TextFieldFormik;
